import { useMutation, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Modal, Table } from "reactstrap";
import {
  DELETE_PERMISSION_BY_ID,
  PERMISSION_DELETED_STATUS_UPDATE,
} from "../../GraphQL/Mutation";
import { GET_ALL_PERMISSIONS } from "../../GraphQL/Queries";
import AddPermission from "./AddPermission";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Pagination } from "@mui/material";
import { usePagination } from "../../utils/helpers";
import { decryption } from "../HelperFunctions";
import { successMessage, warningMessage } from "../ReactToastify";
import Swal from "sweetalert2";
import { capitalize } from "@mui/material";
import BreadCrumb from "../../shared/components/BreadCrumb/BreadCrumb";
import Loader from "../Account/Profile/components/Loader";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";

const Permission = () => {
  const getAllPermission = useQuery(GET_ALL_PERMISSIONS);
  const [deletePermissionById] = useMutation(PERMISSION_DELETED_STATUS_UPDATE);
  const [modal, setModal] = useState(false);
  const [allPermissions, setAllPermissions] = useState([]);
  useEffect(() => {
    if (getAllPermission?.data?.getPermissions?.length) {
      setAllPermissions(getAllPermission?.data?.getPermissions);
      getAllPermission.refetch();
    }
  }, [getAllPermission?.data?.getPermissions?.length]);
  const toggle = () => {
    setModal((prevState) => !prevState);
  };
  // delete permission
  const deletePermission = async (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this permission?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap",
        confirmButton: "order-2",
        denyButton: "order-3",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const result = await deletePermissionById({
          variables: {
            id: id,
          },
        });
        getAllPermission?.refetch();
        if (result?.data?.permissionDeletedStatusUpdate?.result_code == "002") {
          Swal.fire(
            result?.data?.permissionDeletedStatusUpdate?.status,
            "",
            "error"
          );
        }
        if (result?.data?.permissionDeletedStatusUpdate?.result_code == "000") {
          Swal.fire(
            result?.data?.permissionDeletedStatusUpdate?.status,
            "",
            "success"
          );
        }
      }
    });
  };

  // material pagination
  let [page, setPage] = useState(1);
  const PER_PAGE = 10;
  const count = Math.ceil(allPermissions?.length / PER_PAGE);
  const pageData = usePagination(allPermissions, PER_PAGE);
  const handleChange = (e, p) => {
    setPage(p);
    pageData.jump(p);
  };
  // permission
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "Permission ",
    },
  ];
  return (
    <Col>
      <Card>
        <CardBody>
          <BreadCrumb breadCrumbData={breadCrumbData} />
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="page-title mb-0">Permission Lists</h3>
            {permissions?.includes("create_permission") && (
              <button className="btn btn-success" onClick={toggle}>
                + Create Permission
              </button>
            )}
          </div>
          <Table role="table" striped hover responsive>
            <thead>
              <tr role="row">
                <th>#</th>
                <th>Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {getAllPermission?.loading ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    <SubmitLoading color="black" />
                  </td>
                </tr>
              ) : (
                pageData?.currentData()?.map((data) => (
                  <tr key={data?.id} role="row">
                    <th scope="row">{data?.id}</th>
                    <td>
                      {capitalize(data?.permission_name.replace("_", " "))}
                    </td>
                    <td>
                      {permissions?.includes("delete_permission") && (
                        <button
                          className="inbox__email-btn"
                          type="button"
                          aria-label="delete"
                          onClick={() => deletePermission(data?.id)}
                        >
                          <DeleteIcon fontSize="small" />
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          <Pagination count={count} page={page} onChange={handleChange} />
        </CardBody>
      </Card>

      <Modal
        isOpen={modal}
        toggle={toggle}
        animation={true}
        centered
        className="theme-light ltr-support login-modal-form"
      >
        <AddPermission toggle={toggle} refetch={getAllPermission.refetch} />
      </Modal>
    </Col>
  );
};

export default Permission;
